module.exports = __webpack_public_path__ + "dash_20_app_assets/img/profile.967d3de9.png";